import {useSyncExternalStore} from 'react';

import {toClassroomIds} from 'client/TeacherDashboard/SkillPaths/hooks/skillPathEntryFilters';

import {getHandledIds, handledCountIn, subscribeToHandled} from '../api/mockApi';
import {useSkillRecommendationsCountQuery} from '../queries/SkillRecommendations.queries.generated';

import {inboxFilter} from './useRecommendedSkills';

/**
 * How many recommendations are proposed in scope (one class, or every active class), less the ones
 * the mock approve already took. Undefined while it loads and while `isEnabled` is false, which
 * skips the request.
 */
export const useRecommendedSkillsCount = (classroomId: string | undefined, isEnabled: boolean) => {
  const classroomIds = toClassroomIds(classroomId);
  const {data} = useSkillRecommendationsCountQuery({
    variables: {filter: inboxFilter(classroomIds)},
    skip: !isEnabled,
    fetchPolicy: 'cache-and-network'
  });
  useSyncExternalStore(subscribeToHandled, getHandledIds);
  const count = data?.skillRecommendationsAsEducator?.count;
  return count == null ? undefined : Math.max(0, count - handledCountIn({classroomIds}));
};
